import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { today } from "../../../util/formatDate";
import "./PatrolSecurity.css";

const PatrolSecurity = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;

  const getTim = localStorage.getItem("user");
  const jsonTim = JSON.parse(getTim);

  const [statusCode, setStatusCode] = useState();
  const [dataPatrol, setDataPatrol] = useState();
  const [dateFilter, setDateFilter] = useState(today);

  const getTableData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/patrolSecurity`,
        {
          tim: jsonTim.tim,
          date: moment(dateFilter).format("ddd MMM DD YYYY"),
        },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      if (response.data.code === 404) {
        setStatusCode(response.data.code);
        setDataPatrol([]); // kosongkan data tanggal sebelumnya
      } else {
        setStatusCode();
        setDataPatrol(response.data.data);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    getTableData();
  }, [dateFilter]);

  const isEmpty = statusCode === 404 || (dataPatrol && dataPatrol.length === 0);

  return (
    <div className="container-patrol">
      <div className="wrapper-card-patrol">
        <div className="patrol-header">
          <div>
            <h2 className="patrol-title">Patrol Security</h2>
            <p className="patrol-subtitle">
              {dataPatrol && dataPatrol.length > 0
                ? `${dataPatrol.length} laporan patroli`
                : "Riwayat patroli per tanggal"}
            </p>
          </div>
          <input
            className="patrol-date"
            type="date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          />
        </div>

        <div className="patrol-table-scroll">
          <table className="patrol-table">
            <thead>
              <tr>
                <th className="col-no">No.</th>
                <th>Tanggal</th>
                <th>Waktu</th>
                <th>Tempat</th>
                <th>Pembuat</th>
              </tr>
            </thead>
            <tbody>
              {dataPatrol &&
                dataPatrol.map((e, index) => (
                  <tr key={index}>
                    <td className="col-no">{index + 1}</td>
                    <td>{e.date}</td>
                    <td className="col-time">{e.time}</td>
                    <td>
                      <span className="patrol-place">
                        {e.place.replaceAll("_", " ")}
                      </span>
                    </td>
                    <td>{e.creator}</td>
                  </tr>
                ))}
            </tbody>
          </table>

          {isEmpty && (
            <div className="patrol-empty">
              <p>Tidak ada data patroli</p>
              <span>Coba pilih tanggal lain.</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default PatrolSecurity;
